
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAutonomousMarineRadioDeviceIec as ObiAutonomousMarineRadioDeviceIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-autonomous-marine-radio-device-iec.js';
 
 
 

 
 export const ObiAutonomousMarineRadioDeviceIec = createComponent({
   react: React,
   tagName: 'obi-autonomous-marine-radio-device-iec',
   elementClass: ObiAutonomousMarineRadioDeviceIecElement,
   events: {
     
   }
  });
 
 